import React, { ReactNode } from "react";
import { NavLink } from "react-router-dom";
import Header from "../../../../components/Header/Header";
import Tabs from "../../../../components/Tabs/Tabs";
import mes_tab_data from "../../../../assets/mockedData/mes_tab_data";
import { savePathToLocalStorage } from "../../../../utils/helpers";

type Props = {
  title?: string;
  children: ReactNode;
};

const LabosShell = ({ title, children }: Props) => {
  savePathToLocalStorage();
  return (
    <div className="mes-page labos-page">
      <Header title={title || "MES - Laboratorij"} />
      <div className="main-content-flex">
        <Tabs data={mes_tab_data} />
        <div className="section mes-content fq-content">
          <nav className="fq-subnav" aria-label="Laboratorij">
            <NavLink to="/mes/labos/nalozi" activeClassName="active">
              Labos nalozi
            </NavLink>
            <NavLink to="/mes/labos/mjerenja" activeClassName="active">
              Labos mjerenja
            </NavLink>
          </nav>
          {children}
        </div>
      </div>
    </div>
  );
};

export default LabosShell;
